/**
 * Annex Template Service - API de plantillas de anexos (solo lectura)
 * Endpoints: GET /admin/hiring/annex-templates
 * @module services/annexTemplateService
 */

import { api } from './api';
import type { AnnexTemplate, AnnexTemplateCategory } from '@/types/contracts';

const BASE_PATH = '/admin/hiring/annex-templates';

export const annexTemplateService = {
  /**
   * Listar plantillas de anexos (opcionalmente filtradas por categoría)
   */
  async getTemplates(category?: string): Promise<AnnexTemplate[]> {
    const params = category !== undefined ? { category } : undefined;
    const { data } = await api.get<AnnexTemplate[]>(BASE_PATH, { params });
    return Array.isArray(data) ? data : [];
  },

  /**
   * Listar categorías con cantidad de plantillas
   */
  async getCategories(): Promise<AnnexTemplateCategory[]> {
    const { data } = await api.get<AnnexTemplateCategory[]>(`${BASE_PATH}/categories`);
    return Array.isArray(data) ? data : [];
  },

  /**
   * Obtener plantilla por slug (incluye content completo)
   * slug puede contener barras ej: arraigos/anexo_arraigo_social
   */
  async getBySlug(slug: string): Promise<AnnexTemplate> {
    const { data } = await api.get<AnnexTemplate>(`${BASE_PATH}/${slug}`);
    return data;
  },
};

/**
 * Escapa caracteres especiales de regex para evitar ReDoS o fallos
 */
function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Sustituir placeholders [NOMBRE] en el contenido por valores
 */
export function replacePlaceholders(
  content: string,
  values: Record<string, string>
): string {
  let out = content;
  for (const [key, value] of Object.entries(values)) {
    const safeKey = escapeRegex(key);
    out = out.replace(new RegExp(`\\[${safeKey}\\]`, 'g'), value ?? '');
  }
  return out;
}
